import React, { useEffect, useMemo } from "react";
import "./SalesAdjustmentReport.css";
import SalesAdjustmentReportHeader from "./SalesAdjustmentReportHeader/SalesAdjustmentReportHeader";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import {
  getSalesAdjustmentReportItem,
  getSalesAdjustmentReportPrint,
  getSalesAdjustmentReportColumnValue,
  getSalesAdjustmentReportColumn
} from "../../redux/actions/salesAdjustmentReport.action"
import { Button } from "antd";
import { useLocation } from "react-router-dom";
import { currencySymbol } from "../../utils/constants";
import numeral from "numeral";
import { TabTitle } from "../../utils/GeneralFunction";

const SalesAdjustmentReport = ({ token }) => {
  TabTitle('Sale Order Adjustment Report')
  const dispatch = useDispatch();
  const {
    salesAdjustmentPrint,
    saleAdjustmentColumn,
    saleAdjustmentColumnValue,
  } = useSelector((state) => state);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();

  let order_header_adj_id = query.get("order_header_adj_id")

  const footerData =
    salesAdjustmentPrint && salesAdjustmentPrint?.payload?.data[0];


  let groupValues =
    saleAdjustmentColumnValue &&
    saleAdjustmentColumnValue?.payload?.data.reduce(function (r, a) {
      r[a.gender_category_id] = r[a.gender_category_id] || [];
      r[a.gender_category_id].push(a);
      return r;
    }, Object.create(null));

  const groupedColumnValue = groupValues && Object.values(groupValues);

  const values = {

    order_header_adj_id: order_header_adj_id,
  };

  useEffect(() => {
    dispatch(getSalesAdjustmentReportItem(token, values));
    dispatch(getSalesAdjustmentReportPrint(token, values));
    dispatch(getSalesAdjustmentReportColumnValue(token, values));
    dispatch(getSalesAdjustmentReportColumn(token, values));
  }, []);

  const myData = useMemo(() => {
    return saleAdjustmentColumn?.payload?.data.map((it, i) => {
      return {
        column: it,
        detail: groupedColumnValue && groupedColumnValue[i],
      };
    });
  }, [groupedColumnValue, saleAdjustmentColumn]);

  const handlePrint = () => {
    const css = '@page { size: landscape; }';
    const style = document.createElement('style');
    style.innerHTML = css;
    document.head.appendChild(style);
    window.print();
    document.head.removeChild(style); // Clean up after print
  };

  if (salesAdjustmentPrint?.loading) {
    return <>
      <div className='loaderDiv' >
        <Loader
          type="Grid"
          color="#212121"
          height={40}
          width={40}
        />
      </div>
    </>
  }

  return (
    <div className="__sale_adjustment_report"    >
      <table width="100%">
        <thead>
          <tr>
            <td>
              <SalesAdjustmentReportHeader />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="no-print">
            <td>
              <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px', marginRight: "114px" }}>
                <Button type="primary" onClick={handlePrint}>
                  Print
                </Button>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <Body myData={myData} footerData={footerData} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default SalesAdjustmentReport;

const Body = ({ myData, footerData }) => {
  return (
    <>
      <div className="__content">
        <div className="__list_items">
          {myData?.map((size, index) => {
            return (
              <table key={index} width="100%">
                <thead>
                  <tr>
                    <th
                      style={{
                        width: "36px",
                      }}
                    >
                      S.No
                    </th>
                    <th
                      style={{
                        width: "88px",
                      }}
                    >
                      SKU #
                    </th>
                    <th
                      style={{
                        width: "80px",
                      }}
                    >
                      Brand
                    </th>
                    <th
                      style={{
                        width: "240px",
                      }}
                    >
                      Style/Desc
                      <span style={{ marginLeft: "5px" }}>
                        {size?.column?.gender_category_name}
                      </span>
                    </th>
                    <th
                      className="__size_col"
                    >
                      {size.column.hq23 && size.column.hq23}
                    </th>
                    <th className="__size_col">
                      {size.column.hq24 && size.column.hq24}
                    </th>
                    <th className="__size_col">
                      {size.column.hq25 && size.column.hq25}
                    </th>
                    <th className="__size_col">
                      {size.column.hq26 && size.column.hq26}
                    </th>
                    <th className="__size_col">
                      {size.column.hq27 && size.column.hq27}
                    </th>
                    <th className="__size_col">
                      {size.column.hq28 && size.column.hq28}
                    </th>
                    <th className="__size_col">
                      {size.column.hq29 && size.column.hq29}
                    </th>
                    <th className="__size_col">
                      {size.column.hq30 && size.column.hq30}
                    </th>
                    <th className="__size_col">
                      {size.column.hq31 && size.column.hq31}
                    </th>
                    <th className="__size_col">
                      {size.column.hq32 && size.column.hq32}
                    </th>
                    <th className="__size_col">
                      {size.column.hq33 && size.column.hq33}
                    </th>
                    <th className="__size_col">
                      {size.column.hq34 && size.column.hq34}
                    </th>
                    <th className="__size_col">
                      {size.column.hq35 && size.column.hq35}
                    </th>
                    <th className="__size_col">
                      {size.column.hq36 && size.column.hq36}
                    </th>
                    <th className="__size_col">
                      {size.column.hq37 && size.column.hq37}
                    </th>
                    <th className="__size_col">
                      {size.column.hq38 && size.column.hq38}
                    </th>
                    <th
                      style={{
                        width: "50px",
                      }}
                    >
                      Quantity
                    </th>
                    <th
                      style={{
                        width: "65px",
                      }}
                    >
                      Rate
                    </th>
                    <th
                      style={{
                        width: "90px",
                      }}
                    >
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {size.detail?.map((it, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td
                          style={{
                            marginLeft: "0",
                          }}
                        >
                          {it.item_code}
                        </td>
                        <td>
                          {footerData?.brand_name}
                        </td>
                        <td>
                          {it.description}
                        </td>
                        <td className="__size_col">
                          {it.q23 && Number(it.q23).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q24 && Number(it.q24).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q25 && Number(it.q25).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q26 && Number(it.q26).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q27 && Number(it.q27).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q28 && Number(it.q28).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q29 && Number(it.q29).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q30 && Number(it.q30).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q31 && Number(it.q31).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q32 && Number(it.q32).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q33 && Number(it.q33).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q34 && Number(it.q34).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q35 && Number(it.q35).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q36 && Number(it.q36).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q37 && Number(it.q37).toFixed(0)}
                        </td>
                        <td className="__size_col">
                          {it.q38 && Number(it.q38).toFixed(0)}
                        </td>
                        <td>
                          {it.item_quantity && Number(it.item_quantity).toFixed(0)}
                        </td>
                        <td style={{whiteSpace:'nowrap'}}>{currencySymbol}{it.rate && it.rate}</td>
                        <td style={{whiteSpace:'nowrap'}}>{currencySymbol}{it.amount && Number(it.amount).toFixed(2)}</td>
                      </tr>
                    );
                  })}
                  {Array.isArray(myData) && index === myData.length - 1 &&
                    <>
                      <tr>
                        <td colSpan={22} style={{ height: "15px", border: 0 }}></td>
                      </tr>
                      <tr>
                        <td colSpan={18} style={{ border: 0 }}></td>
                        <td colSpan="2"><p>Total</p></td>
                        <td>{footerData && footerData.sum_quantity}</td>
                        <td></td>
                        <td>{currencySymbol}{numeral(footerData.sum_gross_amount).format("0.00")}</td>
                      </tr>
                      <tr>
                        <td colSpan={18} style={{ border: 0 }}></td>
                        <td colSpan="2"><p>Disc %</p></td>
                        <td></td>
                        <td></td>
                        <td>0.00 %</td>
                      </tr>
                      <tr>
                        <td colSpan={18} style={{ border: 0 }}></td>
                        <td colSpan="2"><p>Disc Amount</p></td>
                        <td></td>
                        <td></td>
                        <td>{currencySymbol}{footerData && numeral(footerData.discount).format("0.00")}</td>
                      </tr>
                      <tr>
                        <td colSpan={18} style={{ border: 0 }}></td>
                        <td colSpan="2"><p>S.Tax Amount</p></td>
                        <td></td>
                        <td></td>
                        <td>{currencySymbol}{footerData && numeral(footerData.tax_percent).format("0.00")}</td>
                      </tr>
                      <tr>
                        <td colSpan={18} style={{ border: 0 }}></td>
                        <td colSpan="2"><p>Net Amount</p></td>
                        <td></td>
                        <td></td>
                        <td>{currencySymbol}{footerData && numeral(footerData.net_amount).format("0.00")}</td>
                      </tr>
                    </>
                  }
                </tbody>
              </table>
            );
          })}
        </div>
      </div>
    </>
  )
}